// extracted by mini-css-extract-plugin
export default {"root_image_inner":"testimonialsForm_root_image_inner__NKEtu"};